<script setup lang="ts">
defineProps<{ src: string | undefined; alt: string; size: 'compact' | 'wide' }>()

const SIZE_CLASS = {
  compact: 'h-11 w-12',
  wide: 'h-16 w-24',
} as const
</script>

<template>
  <img
    v-if="src !== undefined"
    :src="src"
    :alt="alt"
    class="shrink-0 rounded-[var(--radius-control)] border border-[color:var(--color-border)] object-cover"
    :class="SIZE_CLASS[size]"
  />
  <span
    v-else
    class="flex shrink-0 items-center justify-center rounded-[var(--radius-control)] border border-[color:var(--color-border)] bg-[color:var(--color-surface-sunken)] text-[color:var(--color-text-muted)]"
    :class="SIZE_CLASS[size]"
  >
    <svg
      width="24"
      height="24"
      viewBox="0 0 16 16"
      aria-hidden="true"
      fill="none"
      stroke="currentColor"
      stroke-width="1.4"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <path d="M2.5 10.2V7.6l1.6-3h7.8l1.6 3v2.6M2.5 10.2h11M2.5 10.2v1.3h2v-1.3M13.5 10.2v1.3h-2v-1.3" />
      <circle cx="5" cy="10.5" r="1" />
      <circle cx="11" cy="10.5" r="1" />
    </svg>
  </span>
</template>
